'use strict';

bbw.directive.bbwToggle = ['safeApply', function(safeApply) {
    return {
        restrict: 'A',
        template: '<ng-transclude></ng-transclude>',
        transclude: true,
        scope: {
            bbwToggle: '=bbwToggle',
            bbwToggleDefault: '&bbwToggleDefault',
            bbwToggleClass: '@bbwToggleClass'
        },
        link: function(scope, element) {
            var toggleClass = scope.bbwToggleClass;
            var defaultValue = scope.bbwToggleDefault();
            if (angular.isDefined(defaultValue)) {
                scope.bbwToggle = !!defaultValue;
            } else {
                scope.bbwToggle = !!scope.bbwToggle;
            }
            var updateClass = angular.isUndefined(toggleClass) ? angular.noop : function() {
                if (scope.bbwToggle) {
                    element.addClass(toggleClass);
                } else {
                    element.removeClass(toggleClass);
                }
            };
            element.on('click', function() {
                safeApply(function() {
                    scope.bbwToggle = !scope.bbwToggle;
                }, scope);
            });
            updateClass();
            scope.$watch('bbwToggle', updateClass);
        }
    };
}];
